const isImageLoaded = ($img) => {
	if (!$img.complete) return false;
	if (typeof $img.naturalWidth !== 'undefined' && $img.naturalWidth === 0) return false;
	return true;
};

const imageSizeTranslation = (columnWidth = '', imageObj, seperator = '-', lazyLoad = true, limitLower = false, imageWidth = false) => {
	const returnObj = {};
	const useLazy = lazyLoad !== false;
	let width = 1;
	columnWidth = columnWidth.toString();
	if (!imageObj || Object.keys(imageObj).length === 0) return {};
	if (imageObj.src) imageObj.url = imageObj.src;
	if (/\.(svg|gif)$/.test(imageObj.url)) columnWidth = 'noResize';
	const imageName = imageObj.url.slice(0, imageObj.url.lastIndexOf('.'));
	const imageExt = imageObj.url.slice(imageObj.url.lastIndexOf('.'));

	if (useLazy && lazyLoad === 'eager') returnObj.loading = 'eager';
	else if (useLazy) returnObj.loading = 'lazy';
	if (imageWidth !== false) {
		returnObj.src = `${imageName}${seperator}${imageWidth}x${imageExt}`;
		returnObj.alt = imageObj.alt;
		returnObj.width = imageWidth;
		if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * imageWidth);
		return returnObj;
	}

	switch (columnWidth) {
		case 'full':
			width = 2600;
			returnObj.src = `${imageName}${seperator}2600x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}2600x${imageExt} 2600w, ${imageName}${seperator}2400x${imageExt} 2400w, ${imageName}${seperator}1800x${imageExt} 1800w${(limitLower ? '' : `, ${imageName}${seperator}1200x${imageExt} 1200w, ${imageName}${seperator}600x${imageExt} 600w`)}`;
			break;
		case '12':
		case '11':
		case '10':
			width = 2400;
			returnObj.src = `${imageName}${seperator}2400x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}2400x${imageExt} 2400w, ${imageName}${seperator}1800x${imageExt} 1800w${(limitLower ? '' : `, ${imageName}${seperator}1200x${imageExt} 1200w, ${imageName}${seperator}600x${imageExt} 600w`)}`;
			break;
		case '9':
		case '8':
		case '7':
			width = 1800;
			returnObj.src = `${imageName}${seperator}1800x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}1800x${imageExt} 1800w${(limitLower ? '' : `, ${imageName}${seperator}1200x${imageExt} 1200w, ${imageName}${seperator}600x${imageExt} 600w`)}`;
			break;
		case '6':
		case '5':
		case '4':
			width = 1200;
			returnObj.src = `${imageName}${seperator}1200x${imageExt}`;
			returnObj.srcSet = `${imageName}${seperator}1200x${imageExt} 1200w, ${imageName}${seperator}600x${imageExt} 600w`;
			break;
		case '3':
		case '2':
		case '1':
			width = 600;
			returnObj.src = `${imageName}${seperator}600x${imageExt}`;
			break;
		default:
			width = imageObj.width;
			returnObj.src = imageObj.url;
	}
	returnObj.alt = imageObj.alt;
	returnObj.width = width;
	if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * width);

	return returnObj;
};

const productImageSizeTranslation = (columnWidth = '', image, lazyLoad, limitLower = false) => {
	const returnObj = {};
	const useLazy = lazyLoad !== false;
	let width = 1;
	const format = image.slice(image.lastIndexOf('.'));
	const baseFile = image.slice(0, image.lastIndexOf('.'));
	columnWidth = columnWidth.toString();
	if (/\.(svg|gif)$/.test(image)) columnWidth = 'noResize';

	switch (columnWidth) {
		case 'full':
			width = 2000;
			returnObj.src = `${baseFile}-jeanZoom${format}`;
			returnObj.srcSet = `${baseFile}-jeanZoom${format} 2000w, ${baseFile}-jeanLarge${format} 1600w, ${baseFile}-jeanMedium${format} 1200w${(limitLower ? '' : `, ${baseFile}${format} 800w, ${baseFile}-jeanStandard${format} 500w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 500px) 500px, (max-width: 800px) 800px, ')}(max-width: 1200px) 1200px, (max-width: 1600px) 1600px, 2000px`;
			break;
		case '12':
		case '11':
		case '10':
			width = 1600;
			returnObj.src = `${baseFile}-jeanLarge${format}`;
			returnObj.srcSet = `${baseFile}-jeanLarge${format} 1600w, ${baseFile}-jeanMedium${format} 1200w${(limitLower ? '' : `, ${baseFile}${format} 800w, ${baseFile}-jeanStandard${format} 500w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 500px) 500px, (max-width: 800px) 800px, ')}(max-width: 1200px) 1200px, 1600px`;
			break;
		case '9':
		case '8':
		case '7':
			width = 1200;
			returnObj.src = `${baseFile}-jeanMedium${format}`;
			returnObj.srcSet = `${baseFile}-jeanMedium${format} 1200w${(limitLower ? '' : `, ${baseFile}${format} 800w, ${baseFile}-jeanStandard${format} 500w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 500px) 500px, (max-width: 800px) 800px, ')}1200px`;
			break;
		case '6':
		case '5':
		case '4':
			width = 800;
			returnObj.src = `${baseFile}${format}`;
			returnObj.srcSet = `${baseFile}${format} 800w, ${baseFile}-jeanStandard${format} 500w`;
			returnObj.sizes = '(max-width: 500px) 500px, 800px';
			break;
		case '3':
		case '2':
		case '1':
			width = 500;
			returnObj.src = `${baseFile}-jeanStandard${format}`;
			break;
		default:
			width = 800;
			returnObj.src = image;
	}
	returnObj.width = width;
	returnObj.height = width;
	if (useLazy) returnObj.loading = 'lazy';

	return returnObj;
};

export { isImageLoaded, imageSizeTranslation, productImageSizeTranslation };
